import {
  UserHistoryPayments,
  UserHistoryPaymentsWithholding,
  UserHistoryWithholdingsWithholding,
} from "@letsbit/malcolmlb";

export enum RECEIPT_TYPE {
  DEPOSIT = "deposit",
  WITHDRAW = "withdraw",
  WITHHOLDING = "withholding",
  WITHHOLDINGS_WITHHOLDING = "withholdings_withholding",
}
export interface HistoryDepositDownloadReceiptProps {
  receiptType: RECEIPT_TYPE.DEPOSIT;
  movement: UserHistoryPayments;
}

export interface HistoryWithdrawDownloadReceiptProps {
  receiptType: RECEIPT_TYPE.WITHDRAW;
  movement: UserHistoryPayments;
}

export interface HistoryWithholdingDownloadReceiptProps {
  receiptType: RECEIPT_TYPE.WITHHOLDING;
  movement: UserHistoryPaymentsWithholding;
}

export interface HistoryWithholdingsWithholdingDownloadReceiptProps {
  receiptType: RECEIPT_TYPE.WITHHOLDINGS_WITHHOLDING;
  movement: UserHistoryWithholdingsWithholding;
}

export type HistoryDownloadReceiptProps =
  | HistoryDepositDownloadReceiptProps
  | HistoryWithdrawDownloadReceiptProps
  | HistoryWithholdingDownloadReceiptProps
  | HistoryWithholdingsWithholdingDownloadReceiptProps;
